import { Navigate, Outlet } from 'react-router'
import { useStore } from '../stores/store'

export const ProtectedRouteAdmin = ({ redirectPath }: any) => {
  const { userStore } = useStore()

  if (!userStore.isLoggedIn || !userStore.isAdmin) {
    return <Navigate to={redirectPath} replace />
  }

  return <Outlet />
}
